import { Link } from "react-router-dom";
import { Instagram, Linkedin, Facebook, ArrowUpRight } from "lucide-react";

export const Footer = () => {
    const year = new Date().getFullYear();
    return (
        <footer
            data-testid="site-footer"
            className="bg-[#1A1A1A] text-[#F9F8F6]"
        >
            <div className="px-6 md:px-12 lg:px-24 pt-24 pb-10">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16">
                    <div className="md:col-span-7">
                        <p className="asc-overline text-[#8C7A6B]">Let us begin</p>
                        <h2 className="serif text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05] mt-6">
                            Ready to shape <br />
                            something <br />
                            <span className="italic text-[#C7B8A8]">meaningful?</span>
                        </h2>
                        <Link
                            to="/contact"
                            data-testid="footer-contact-cta"
                            className="inline-flex items-center gap-3 mt-10 text-sm uppercase tracking-[0.22em] border-b border-[#3E3A37] pb-2 hover:text-[#C7B8A8] hover:border-[#C7B8A8] transition-colors"
                        >
                            Begin a conversation <ArrowUpRight size={16} />
                        </Link>
                    </div>

                    <div className="md:col-span-5 grid grid-cols-2 gap-10">
                        <div>
                            <p className="asc-overline text-[#8C7A6B]">Studio</p>
                            <p className="mt-5 text-sm leading-relaxed text-[#C7B8A8]">
                                ASC Interior Co., Ltd.
                                <br />
                                313 Thong Lo 15 Alley
                                <br />
                                Khlong Tan Nuea, Watthana
                                <br />
                                Bangkok 10110, Thailand
                            </p>
                        </div>
                        <div>
                            <p className="asc-overline text-[#8C7A6B]">Reach</p>

                            <p className="mt-5 text-[10px] uppercase tracking-[0.22em] text-[#8C7A6B]">
                                For project inquiries
                            </p>
                            <a
                                href="mailto:info@ascinterior.com"
                                data-testid="footer-email"
                                className="!block mt-1 text-sm asc-link w-fit"
                            >
                                info@ascinterior.com
                            </a>
                            <a
                                href="tel:+6621853103"
                                data-testid="footer-phone"
                                className="!block mt-1 text-sm asc-link w-fit"
                            >
                                +66 2 185 3103
                            </a>

                            <p className="mt-5 text-[10px] uppercase tracking-[0.22em] text-[#8C7A6B]">
                                Career opportunities
                            </p>
                            <a
                                href="mailto:hr@ascinterior.com"
                                data-testid="footer-hr-email"
                                className="!block mt-1 text-sm asc-link w-fit"
                            >
                                hr@ascinterior.com
                            </a>

                            <p className="mt-5 text-[10px] uppercase tracking-[0.22em] text-[#8C7A6B]">
                                Supplier & brand partnerships
                            </p>
                            <a
                                href="mailto:aschub@ascinterior.com"
                                data-testid="footer-partnerships-email"
                                className="!block mt-1 text-sm asc-link w-fit"
                            >
                                aschub@ascinterior.com
                            </a>

                            <div className="mt-8 flex items-center gap-4">
                                <a
                                    href="https://www.facebook.com/ascinterior"
                                    target="_blank"
                                    rel="noreferrer"
                                    data-testid="footer-facebook"
                                    aria-label="Facebook"
                                    className="text-[#C7B8A8] hover:text-[#F9F8F6] transition-colors"
                                >
                                    <Facebook size={18} />
                                </a>
                                <a
                                    href="https://www.instagram.com/ascinterior/"
                                    target="_blank"
                                    rel="noreferrer"
                                    data-testid="footer-instagram"
                                    aria-label="Instagram"
                                    className="text-[#C7B8A8] hover:text-[#F9F8F6] transition-colors"
                                >
                                    <Instagram size={18} />
                                </a>
                                <a
                                    href="https://www.linkedin.com/company/asc-interiors-co.-ltd/"
                                    target="_blank"
                                    rel="noreferrer"
                                    data-testid="footer-linkedin"
                                    aria-label="LinkedIn"
                                    className="text-[#C7B8A8] hover:text-[#F9F8F6] transition-colors"
                                >
                                    <Linkedin size={18} />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="mt-24 pt-8 border-t border-[#3E3A37] flex flex-col md:flex-row justify-between gap-4 text-xs text-[#8C7A6B]">
                    <p>&copy; {year} ASC Interior. All rights reserved.</p>
                    <p>Building spaces, building trust — since 2003.</p>
                </div>
            </div>
        </footer>
    );
};
